import validate from './validate';

const validators = {
  has6Digits: value => /^\d{6}$/i.test(value)
};

const validatorsLive = {
  has6Digits: value => /^\d{1,6}$/i.test(value)
};

const validationErrors = {
  has6Digits: 'Must be 6 digits!'
};

export const checkShopIdLive = (
  shopId => validate(shopId, validatorsLive, validationErrors)
);

export const checkShopId = (
  shopId => validate(shopId, validators, validationErrors)
);

export default checkShopId;
